<template>
  <div class="item-container">
    <div class="info-container">
      <p>
        {{ new Date(equipementIntervention.horodatageAppelClient).toLocaleDateString().replaceAll('-', ' / ') }}
      </p>
      <p>
        {{
          `${$t("equipement.intervention.author")} ${equipementIntervention.demandeur}`
        }}
      </p>
      <p>
        {{ equipementIntervention.libelle }}
      </p>
    </div>
    <StatusTag :status="getTraduction(equipementIntervention.etatDemande)" />
  </div>
</template>

<script lang="ts">
import { EquipementInvervention } from '@/models/EquipementInvervention';
import { defineComponent, PropType } from 'vue';
import StatusTag from '@/components/ui-components/StatusTag.vue';
import StringUtils from '@/common/utils/StringUtils';
import i18n from '@/plugins/i18n';

export default defineComponent({
    components: {StatusTag},
    props: {
        equipementIntervention: {
            type: Object as PropType<EquipementInvervention>,
            required: true,
        },
    },
    methods: {
        getTraduction(libelle: string): string {
            return i18n.global.t(StringUtils.getKeyFromFRTranslation(libelle));
        }
    }
});
</script>

<style scoped>
.info-container {
  width: 600px;
  color: var(--dark-grey);
  font-size: var(--font-size-low-medium);
  font-weight: 400;
}
.item-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
